import { getCommunityNameFromClient } from '@/common/utils/community';
import { getLanguageFromClient } from '@/common/utils/language';
import { getTokenFromClient } from '@/common/utils/auth';
import { parse as parseUserAgent } from '@/common/utils/user-agent';
import { createApp } from './main';

const { app, router } = createApp({
  language: getLanguageFromClient(),
  communityName: getCommunityNameFromClient(),
  token: getTokenFromClient(),
  userAgent: parseUserAgent(navigator.userAgent),
});

router.isReady().then(() => {
  app.mount('#app');
});
